module.exports = __webpack_public_path__ + "static/media/logo.aae0150a.png";